import Node from './node';

export default class Email extends Node {
  clone() {
    return new Email(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
